import React, { Component, useEffect } from "react";
import { useDispatch } from "react-redux";
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";
import "./scss/style.scss";
import "./App.css"
import ProtectedRoute from "./ProtectedRoute";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Login = React.lazy(() =>
  import("./views/components/Authentication/Login")
);
const RegisterUser = React.lazy(() =>
  import("./views/components/Authentication/RegisterUser")
);

const ResetPassword = React.lazy(() =>
  import("./views/components/Authentication/ResetPassword")
);
const ResetPasswordSga = React.lazy(() =>
  import("./views/components/Authentication/ResetPasswordSga")
);
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (token == null) {
      Redirect("/login");
    }
  }, []);

  return (
    <HashRouter>
      <React.Suspense fallback={loading}>
        <Switch>
          <Route
            exact
            path="/login"
            name="Login Page"
            render={(props) => <Login {...props} />}
          />
          <Route
            exact
            path="/register"
            name="Register Page"
            render={(props) => <RegisterUser {...props} />}
          />
          <Route
            exact
            path="/resetpassword"
            name="Register Page"
            render={(props) => <ResetPassword {...props} />}
          />
          <Route
            exact
            path="/resetpasswordsga"
            name="Register Page"
            render={(props) => <ResetPasswordSga {...props} />}
          />
          <Route
            exact
            path="/404"
            name="Page 404"
            render={(props) => <Page404 {...props} />}
          />
          <Route
            exact
            path="/500"
            name="Page 500"
            render={(props) => <Page500 {...props} />}
          />
          <ProtectedRoute
            path="/assurance"
            roles={["ROLE_SADMIN"]}
            name="Assurance Panel"
            component={TheLayout}
          />
          {/*<ProtectedRoute
            path="/"
            roles={["ROLE_ADMIN"]}
            name="Home"
            //component={TheLayout}
            render={(props) => <TheLayout {...props} />}
          />*/}
          <Route
            path="/"
            name="Home"
            render={(props) => <TheLayout {...props} />}
          />
        </Switch>
      </React.Suspense>
    </HashRouter>
  );
};

export default App;
